var installedModules = {};
var moduleToHandlerMapping = {
	8418: {
		getter: () => (Promise.all([__webpack_require__.e(409), __webpack_require__.e(931)]).then(() => (() => (__webpack_require__(1931))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.10",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/core",
	},
	260: {
		getter: () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(11), __webpack_require__.e(964), __webpack_require__.e(595)]).then(() => (() => (__webpack_require__(11))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.10",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/dev-tools-utils",
	},
	2624: {
		getter: () => (Promise.all([__webpack_require__.e(437), __webpack_require__.e(400)]).then(() => (() => (__webpack_require__(8437))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	9178: {
		getter: () => (Promise.all([__webpack_require__.e(409), __webpack_require__.e(580), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(5580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.10",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	2964: {
		getter: () => (__webpack_require__.e(230).then(() => (() => (__webpack_require__(2230))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	4400: {
		getter: () => (__webpack_require__.e(653).then(() => (() => (__webpack_require__(1653))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	6101: {
		getter: () => (Promise.all([__webpack_require__.e(409), __webpack_require__.e(580), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(5580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=0.97.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"341": [
		6101
	],
	"400": [
		4400
	],
	"418": [
		8418
	],
	"608": [
		260,
		2624,
		9178
	],
	"964": [
		2964
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}